module.exports = __webpack_public_path__ + "static/media/36handle-2.b0515ead.png";